import { CobeGlobe } from '../components/ui/CobeGlobe';
import './GlobalPresence.css';

/* ── 4 region markers only, no arcs ── */
const MARKERS = [
  { id: 'na',   location: [40.7128,  -74.006],  label: 'North America' },
  { id: 'eu',   location: [51.5074,   -0.1278], label: 'Europe'        },
  { id: 'me',   location: [25.2048,   55.2708], label: 'Middle East'   },
  { id: 'apac', location: [1.3521,   103.8198], label: 'Asia-Pacific'  },
];

const REGIONS = ['North America', 'Europe', 'Middle East', 'Asia-Pacific'];

export default function GlobalPresence() {
  return (
    <section className="gp-section">
      <div className="gp-inner">

        {/* Globe — left on desktop, top on mobile */}
        <div className="gp-globe-col">
          <CobeGlobe
            markers={MARKERS}
            arcs={[]}
            markerColor={[0.93, 0.17, 0.16]}
            baseColor={[0.9, 0.9, 0.9]}
            arcColor={[0.93, 0.17, 0.16]}
            glowColor={[0.08, 0.08, 0.08]}
            dark={1}
            mapBrightness={4}
            markerSize={0.04}
            markerElevation={0.01}
            arcWidth={0}
            arcHeight={0}
            speed={0.003}
            theta={0.25}
            diffuse={1.5}
            mapSamples={16000}
            className="gp-globe"
          />
        </div>

        {/* Content — right on desktop, bottom on mobile */}
        <div className="gp-content-col">
          <p className="gp-eyebrow">Global Reach</p>

          <h2 className="gp-heading">
            Built globally.<br />
            Working without<br />
            borders.
          </h2>

          <p className="gp-body">
            Aurelix works across time zones, industries and growth stages.
            Whether you're launching something new, rebuilding what already
            exists, or figuring out what comes next — we plug into your
            business where we can create the most leverage.
          </p>

          <div className="gp-regions">
            {REGIONS.map((r) => (
              <span key={r} className="gp-region-tag">{r}</span>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
